export default function createModalContainer(title?: string, message?: string) {
  const container = document.createElement('div');
  container.className = 'md-modal-container';
  document.body.appendChild(container);

  // Dialog
  const dialog = document.createElement('dialog');
  dialog.className = 'md-modal ant-modal-content';
  dialog.title = title ?? 'Confirm';
  dialog.setAttribute('aria-labelledby', 'modal-title');
  dialog.setAttribute('aria-describedby', 'modal-content');
  container.appendChild(dialog);

  const closeDialog = () => {
    dialog.close();
    container.remove();
  };

  const content = document.createElement('div');
  content.innerHTML = message ?? 'Are you sure you want to proceed?';
  content.className = 'md-content ant-modal-body';
  dialog.appendChild(content);

  // Footer
  const footer = document.createElement('div');
  footer.className = 'md-footer ant-modal-footer';
  dialog.appendChild(footer);

  if (!title) {
    return { container, dialog, closeDialog, closeButton: undefined, footer };
  }

  // Title container
  const titleContainer = document.createElement('div');
  titleContainer.className = 'md-title-container ant-modal-header';
  dialog.insertBefore(titleContainer, content);
  // Title
  const titleElement = document.createElement('h2');
  titleElement.textContent = title;
  titleElement.className = 'md-title';
  titleContainer.appendChild(titleElement);
  // Close button
  const closeButton = document.createElement('button');
  closeButton.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
        <path fill="currentColor" d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7a1 1 0 0 0-1.41 1.41L10.59 12l-4.89 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.41z"/>
      </svg>
    `;
  closeButton.className = 'md-close';
  // closeButton.onclick = handleCancel;
  titleContainer.appendChild(closeButton);

  return { container, dialog, closeDialog, closeButton, footer };
}
